import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { TransactionLog } from "../_types/transaction-log";

@Injectable({
    providedIn: 'root',
})
export class TransactionsLogsService extends Service<TransactionLog> {
    public override type = 'transactionLogs';
    public override url = 'invoicing/transactionLogs';
}
